import styled from 'styled-components';

export const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  position: fixed;
  left: 0;
  top: 0;
  width: 23.5rem;
  height: 100%;
  padding: 2rem;
  background: #484888;
  @media (max-width: 875px) {
    display: none;
  }
`;

export const NavLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 10rem;
  height: 100%;
`;

export const Link = styled.span`
  font-size: 2.2rem;
  font-family: 'Avenir-Medium';
  color: #fff;
  text-transform: capitalize;

  padding: 1.2rem 1.3rem;
  padding-left: ${props => (props.$active ? '2.4rem' : '1.2rem')};

  border-radius: 2rem;
  background: ${props => (props.$active ? 'rgba(255, 255, 255, 0.2)' : 'transparent')};
  cursor: pointer;
  user-select: none;
  transition: all 0.3s ease-in-out;

  &:hover {
    padding-left: 2.4rem;
    background: rgba(255, 255, 255, 0.2);
  }

  &:active {
    opacity: 0.45;
  }
`;

export const LogoutDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  margin-top: auto;

  transition: all 0.3s ease-in-out;

  &:active {
    opacity: 0.45;
  }
`;

export const Logout = styled.span`
  font-size: 2.2rem;
  font-family: 'Avenir-Medium';
  color: #fff;
  user-select: none;
  text-transform: capitalize;

  padding: 1.2rem 1.3rem;

  border-radius: 2rem;

  cursor: pointer;

  transition: all 0.3s ease-in-out;

  &:hover {
    padding-left: 2.4rem;
  }
`;
